import { connect } from 'react-redux';
import { IAppState, Dispatch } from '../../../common/state';
import { ECurrentLocations } from '../../../utils/demand';
import { openLocationSwitcher } from '../../state/location_switcher';
import { LocationSwitherButton } from './index';

const LocationSwitherButtonContainer = connect(
  (state: IAppState) => {
    let locationName = '';

    if (state.filters.currentLocation === 'moscow_mo') {
      locationName = ECurrentLocations.moscowAndMO;
    } else if (state.filters.currentLocation === 'spb_lo') {
      locationName = ECurrentLocations.spbAndLO;
    } else {
      locationName = state.filters.currentLocation.displayName;
    }

    return {
      locationName,
    };
  },
  (dispatch: Dispatch) => ({
    onClick: () => {
      dispatch(openLocationSwitcher());
    },
  }),
)(LocationSwitherButton);

// tslint:disable-next-line:no-default-export
export default LocationSwitherButtonContainer;
